import {
  View,
  Text,
  Animated,
  InteractionManager,
  BackHandler,
  Platform,
  // Linking,
  TouchableOpacity,
  FlatList,
  Pressable,
  ScrollView,
  Image,
  Share,
} from "react-native";
import React, {
  useCallback,
  useEffect,
  useState,
  useRef,
  useContext,
} from "react";
import { RootState, dispatch, useSelector } from "../../../redux/store";
import { useNavigation } from "@react-navigation/native";

import dimensions from "../../../globalStyles/dimensions";
import {
  fetchExperience,
  resetExperience,
  setAvailability,
} from "../../../redux/experience/experienceSlice";
import {
  averageRating,
  generateSchedule,
  trimAddress,
} from "../../../utils/experienceUtils";
import WhatsIncluded from "../../../modal/ExperienceModals/WhatsIncluded";
import DateModal from "../../../modal/ExperienceModals/DateModal";
import CustomComponent from "../../../components/CustomComponent";
import GlobalStyles from "../../../globalStyles/globalStyles";
import { Colors } from "../../../globalStyles/ColorConfig";
import { BlurView } from "expo-blur";
import ExperienceIcons from "../../../assets/Icons/ExperienceIcons";
import Tag from "./components/generalComponents/Tag";
import IncludeComponent from "./components/generalComponents/IncludeComponent";
import Experiencelist from "./components/cardComponents/Experiencelist";
import DateSelect from "./components/generalComponents/DateSelect";
import Review from "./components/generalComponents/Review";
import Carousel from "./components/generalComponents/Carousel";
import StaticImages from "../../../assets/StaticImages";
import ExperienceLoader from "./components/loaders/ExperienceLoader";
import CarouselMobile from "./components/generalComponents/CarouselMobile";
import { LinearGradient } from "expo-linear-gradient";
import * as Linking from "expo-linking";
import { makeRedirectUri } from "expo-auth-session";
import ExperienceNotFound from "../../../components/Error/ExperienceNotFound";
import ShareWeb from "../../../modal/ExperienceModals/ShareWeb";

const shadowStyle =
  Platform.OS === "ios"
    ? {
        shadowColor: Colors.black100,
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.3,
        shadowRadius: 4,
      }
    : Platform.OS === "android"
    ? {
        elevation: 20,
      }
    : {
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 0,
        },
        shadowOpacity: 0.15,
        shadowRadius: 25,
        elevation: 1,
      };

export default function Experience({ route }: { route: any }) {

  const scrollRef: any = useRef();
  const { _id: experienceID } = route.params;
  const navigation = useNavigation();
  const [includeModal, setIncludeModal] = useState(false);
  const [active, setActive] = useState(false);
  const [choosedate, setChoosedate] = useState("");

  const [experienceData, setExperienceData] = useState<{
    longitude?: any;
    latitude?: any;
    label?: string;
    mapType?: string;
    reviews?: any;
    included?: any;
    schedulesAvailable?: any;
    mediaUrls?: string[];
    price?: number;
    name?: string;
  }>({});

  const { experience: { data: responseData, isLoading: isLoading, error: error } } = useSelector((state: RootState) => state.experience);

  const { experiences: { data: experiences} } = useSelector((state: RootState) => state.experience);

  const handleIncludeModal = useCallback(() => {
    setIncludeModal((prevState) => !prevState);
  }, []);

  const toggleDate = useCallback(() => {
    setActive((prevState) => !prevState);
  }, []);

  const handleDateSelect = useCallback((date: string) => {
    setChoosedate(date);
  }, []);

  const onPressTouch = () => {
    scrollRef.current?.scrollTo({
      y: 0,
      animated: true,
    });
  };

  useEffect(() => {
    InteractionManager.runAfterInteractions(() => {
      // Your code to run after interactions
      if (!isLoading && responseData) {
        if (!isLoading && responseData) {
          const location = responseData?.location;

          const videoUrls =
            responseData?.media.videos?.map((video: any) => video.url) || [];
          const imageUrls =
            responseData?.media.images?.map((image: any) => image.url) || [];

          const mediaUrls: any = [
            ...videoUrls.filter((url: any) => url), // Filter out empty string URLs
            ...imageUrls.filter((url: any) => url), // Filter out empty string URLs
          ];

          setExperienceData((prevExperienceData) => {
            const updatedData = {
              longitude: location?.longitude,
              latitude: location?.latitude,
              label: location?.name,
              mapType: "standard",
              reviews: responseData?.rating,
              included: responseData?.includedPackages,
              schedulesAvailable: generateSchedule(
                20,
                responseData?.schedulesAvailable
              ),
              mediaUrls: mediaUrls?.length > 0 ? mediaUrls : null,
              price: responseData?.price,
            };
            dispatch(setAvailability(updatedData?.schedulesAvailable));
            return updatedData;
          });
        }
      }
    });
  }, [isLoading, responseData]);

  const fetchExperienceData = useCallback(() => {
    InteractionManager.runAfterInteractions(() => {
      dispatch(fetchExperience({ experienceID }));
    });
  }, [experienceID]);

  useEffect(() => {
    fetchExperienceData();
  }, [fetchExperienceData]);

  useEffect(() => {
    function handleBackButton() {
      if (navigation.isFocused()) {
        dispatch(resetExperience());
      }
    }
    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      handleBackButton
    );
    return () => backHandler.remove();
  }, []);

  const openMapsApp = () => {
    const url: string =
      Platform.select({
        ios: `maps://app?daddr=${experienceData.latitude},${experienceData.longitude}&dirflg=d&label=${experienceData?.name}&t=${experienceData.mapType}` as string,
        android:
          `geo:${experienceData.latitude},${experienceData.longitude}?q=${experienceData.latitude},${experienceData.longitude}(${experienceData.label})&mode=d&t=${experienceData.mapType}` as string,
      }) ||
      `https://maps.google.com/?q=${experienceData.latitude},${experienceData.longitude}`;

    Linking.canOpenURL(url).then((supported) => {
      if (supported) {
        return Linking.openURL(url);
      } else {
        console.error("Don't know how to open URI: " + url);
      }
    });
  };

  const pressBackArrow = () => {
    InteractionManager.runAfterInteractions(() => {
      navigation.goBack();
    });
    dispatch(resetExperience());
  };

  const [isShare, setIsShare] = useState(false);

  const handleShare = async () => {
    setIsShare(!isShare); // try {
  };

  const onShare = async () => {
    try {
      const appName = responseData?.title;
      const appDescription = responseData?.description;
      const appLink = `https://spark.love/spark/experience/?_id=${experienceID}`;

      await Share.share({
        url: `https://spark.love/spark/experience/?_id=${experienceID}"`,
        message: `${appName}: ${appDescription} ${appLink}`,
      });
    } catch (error: any) {
      console.error(error.message);
    }
  };

  if (error) {
    return <Text>Got Error</Text>;
  }

  if(isLoading || !responseData){
    return <ExperienceLoader />
  }

  // if (!isLoading && !responseData && !responseData?.length) {
  //   return <ExperienceNotFound/>
  // }

  return (
    <>
      {includeModal && (
        <WhatsIncluded
          visible={includeModal}
          toggleModal={handleIncludeModal}
        />
      )}
      <DateModal
        isDialog={true}
        isVisible={active}
        toggleModal={toggleDate}
        date={choosedate}
      />
      {isShare && (
        <ShareWeb
          Id={experienceID}
          visible={isShare}
          toggleModal={handleShare}
        />
      )}

      <ScrollView
        showsVerticalScrollIndicator={false}
        style={{ backgroundColor: "#fff" }}
        contentContainerStyle={{
          paddingBottom: 50,
        }}
        scrollEventThrottle={12}
        ref={scrollRef}
        scrollsToTop={true}
      >
        <BlurView
          tint="dark"
          style={{
            position: "absolute",
            zIndex: 1,
            height: 40,
            width: 40,
            borderRadius: 50,
            overflow: "hidden",
            top: dimensions.windowHeight * 0.05,
            left: dimensions.windowWidth * 0.05,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Pressable onPress={pressBackArrow}>
            <ExperienceIcons.BackArrow />
          </Pressable>
        </BlurView>
        <View
          style={{
            width: dimensions.windowWidth,
            // backgroundColor:"#000",
            // height: dimensions.windowHeight / 2,
          }}
        >
          {Platform.OS === "web" ? (
            <Carousel data={experienceData?.mediaUrls} status="experience" />
          ) : (
            <CarouselMobile data={experienceData?.mediaUrls} />
          )}
        </View>
        <View
          style={{
            paddingVertical:
              Platform.OS === "web" ? 30 : dimensions.paddingVertical,
            // // paddingVertical:1,
            paddingHorizontal:
              Platform.OS === "web" ? 20 : dimensions.paddingHorizontal,
            paddingBottom: 10,
          }}
        >
          {/* <Tag
            title="Recommended"
            // opacity={0.5}
            style={[
              GlobalStyles.captionText,
              {
                fontSize: 12,
                color: "rgba(0,0,0,0.4)",
                letterSpacing: -0.3,
                paddingHorizontal: 15,
              },
            ]}
          /> */}

          <CustomComponent.TextView
            title={responseData?.title}
            textStyle={[
              GlobalStyles.title1,
              {
                fontFamily: "EBGaramondBold",
                fontSize: 30,
                color: "#3F3F3F",
                lineHeight: 37,
                letterSpacing: -0.5,
              },
            ]}
          />
          <View
            style={{
              flexDirection: "row",
              alignItems: "flex-start",
              gap: 4,
            }}
          >
            {/* <ExperienceIcons.StarIcon /> */}
            <Text>
              {/* {averageRating(responseData?.rating)} */}
              {/* <View
                style={{
                  width: 3,
                  height: 3,
                  borderRadius: 50,
                  backgroundColor: Colors.black100,
                  marginHorizontal: 4,
                }}
              /> */}
              <Text
                style={[
                  GlobalStyles.captionText,
                  {
                    letterSpacing: -0.4,
                    fontSize: 18,
                    color: "rgba(0,0,0,0.6)",
                    fontFamily: "EBGaramondMedium",
                  },
                ]}
              >{`${trimAddress(responseData?.location?.name)}`}</Text>
              {/* <View
                style={{
                  width: 3,
                  height: 3,
                  borderRadius: 50,
                  backgroundColor: Colors.black100,
                  marginHorizontal: 4,
                }}
              />
              <Text>3 hours</Text> */}
            </Text>
          </View>

          {responseData?.description && (
            <CustomComponent.TextView
              title={responseData?.description}
              textStyle={[
                GlobalStyles.bodyText,
                {
                  fontSize: 14,
                  letterSpacing: -0.5,
                  fontFamily: "InterMedium",
                  color: "rgba(0,0,0,0.3)",
                },
              ]}
              boxStyle={{ paddingTop: 10, paddingBottom: 15 }}
            />
          )}
          {/* <CustomComponent.SolidDivider
            style={{
              width: dimensions.windowWidth / 1.12,
              height: 0.5,
              backgroundColor: Colors.black100,
              justifyContent: "center",
              alignSelf: "center",
              opacity: 0.2,
            }}
          /> */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              left: -20,
              marginTop: 15,
            }}
          >
            <ExperienceIcons.WayLine />
          </View>
          <CustomComponent.TextView
            title="What’s included"
            textStyle={[
              GlobalStyles.title1,
              {
                fontFamily: "EBGaramondBold",
                fontSize: 26,
                color: "#3F3F3F",
                lineHeight: 37,
                letterSpacing: -0.5,
              },
            ]}
            boxStyle={{ paddingTop: dimensions.paddingVertical }}
          />
        </View>
        
        <FlatList
            data={experienceData.included}
            keyExtractor={(item,index) => index.toString()}
            renderItem={(item) => (
              <IncludeComponent item={item} toggle={handleIncludeModal} />
            )}
            horizontal={true}
            showsHorizontalScrollIndicator={false}
            contentContainerStyle={{
              gap: 10,
              paddingVertical: 10,
              paddingHorizontal:
                Platform.OS === "web" ? 20 : dimensions.paddingHorizontal,
            }}
          />

<View
            style={{
              paddingTop: dimensions.paddingVertical,
              paddingHorizontal: dimensions.paddingHorizontal,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                marginTop: 5,
                marginBottom: 10,
              }}
            >
              <ExperienceIcons.WayLine />
            </View>
            <CustomComponent.TextView
              title="Where will you both be"
              textStyle={[
                GlobalStyles.title1,
                {
                  fontFamily: "EBGaramondBold",
                  fontSize: 26,
                  color: "#3F3F3F",
                  lineHeight: 37,
                  letterSpacing: -0.5,
                },
              ]}
              boxStyle={{ paddingVertical: 10 }}
            />
            {/* <StaticImages.Map /> */}
            <Pressable onPress={openMapsApp}>
              <Image
                source={StaticImages.Map}
                style={{
                  width: dimensions.windowWidth / 1.12,
                  height: dimensions.windowHeight / 3,
                  borderRadius: 10,
                  marginTop: 5,
                  marginBottom: 10,
                }}
              />
            </Pressable>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                marginTop: 15,
              }}
            >
              <ExperienceIcons.WayLine />
            </View>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                paddingVertical: dimensions.paddingVertical,
              }}
            >
              {responseData?.rating && (
                <>
                  <ExperienceIcons.BigStar />
                  <CustomComponent.TextView
                    title={`${averageRating(responseData?.rating)}`}
                    textStyle={GlobalStyles.title1}
                  />
                </>
              )}
            </View>
          </View>
          {experienceData?.reviews && (
            <FlatList
              data={experienceData.reviews}
              keyExtractor={(item,index) => index.toString()}
              renderItem={({ item }) => <Review item={item} />}
              horizontal={true}
              showsHorizontalScrollIndicator={false}
              contentContainerStyle={{
                gap: 10,
                paddingVertical: dimensions.paddingVertical / 2,
                paddingHorizontal:
                  Platform.OS === "web" ? 20 : dimensions.paddingHorizontal,
              }}
            />
          )}

          <View
            style={{
              paddingTop: dimensions.paddingVertical,
              paddingHorizontal: dimensions.paddingHorizontal,
            }}
          >
            <CustomComponent.SolidDivider
              style={{
                width: dimensions.windowWidth / 1.12,
                height: 0.5,
                backgroundColor: Colors.black100,
                justifyContent: "center",
                alignSelf: "center",
                opacity: 0.2,
                marginVertical: dimensions.marginVertical,
              }}
            />
            <Animated.View>
              <CustomComponent.TextView
                title="Choose from available date"
                textStyle={[
                  GlobalStyles.title1,
                  {
                    fontSize: 24,
                  },
                ]}
              />
            </Animated.View>
            {experienceData?.schedulesAvailable && (
              <CustomComponent.TextView
                title={`${experienceData?.schedulesAvailable?.length} dates available`}
                textStyle={[
                  GlobalStyles.captionText,
                  {
                    opacity: 0.5,
                  },
                ]}
              />
            )}
          </View>
          {experienceData?.schedulesAvailable && (
              <FlatList
                data={experienceData.schedulesAvailable}
                keyExtractor={(item,index) => index.toString()}
                renderItem={({ item }) => (
                  <DateSelect
                    item={item}
                    onPress={toggleDate}
                    handleDateSelect={handleDateSelect}
                    price={experienceData?.price}
                  />
                )}
                horizontal={true}
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={{
                  gap: 10,
                  paddingVertical: dimensions.paddingVertical / 2,
                  paddingHorizontal: 20,
                  marginTop: 10
                }}
              />
            )}
          <View style={{
              paddingTop: dimensions.paddingVertical,
              paddingHorizontal: dimensions.paddingHorizontal,
            }}>
            <View
              style={{
                paddingTop: dimensions.paddingVertical,
                // paddingHorizontal: dimensions.paddingHorizontal,
              }}
            >
              <CustomComponent.SolidDivider
                style={{
                  width: dimensions.windowWidth / 1.12,
                  height: 0.5,
                  backgroundColor: Colors.black100,
                  justifyContent: "center",
                  alignSelf: "center",
                  opacity: 0.2,
                  marginVertical: dimensions.marginVertical,
                }}
              />
              <TouchableOpacity
                onPress={() => Linking.openURL('https://spark.love/terms-conditions')}
                style={{ paddingVertical: dimensions.paddingVertical / 2 }}
              >
                <CustomComponent.TextView
                  title="Cancellation policy"
                  textStyle={[GlobalStyles.heading3, {}]}
                />
                <CustomComponent.TextView
                  title="Cancel 24 hours before the start time for the refund"
                  textStyle={[
                    GlobalStyles.bodyText,
                    {
                      opacity: 0.6,
                    },
                  ]}
                />
              </TouchableOpacity>
              <CustomComponent.SolidDivider
                style={{
                  width: dimensions.windowWidth / 1.12,
                  height: 0.5,
                  backgroundColor: Colors.black100,
                  justifyContent: "center",
                  alignSelf: "center",
                  opacity: 0.2,
                  marginVertical: dimensions.marginVertical * 2,
                }}
              />
            </View>
            <CustomComponent.TextView
              title="Similar experiences"
              textStyle={[GlobalStyles.heading3,{
                fontFamily: "EBGaramondBold",
                fontSize: 26,
                color: "#3F3F3F",
                lineHeight: 37,
                letterSpacing: -0.5,
              }]}
            />
          </View>
          <Experiencelist
            data={experiences}
            horizontal={true}
            contentContainerStyle={{
              gap: 10,
              paddingHorizontal: dimensions.paddingHorizontal,
              paddingBottom:36
            }}
            scrollfunction={onPressTouch}
          />
        
      </ScrollView>
      <View
        style={{
          position: "absolute",
          width: "100%",
          zIndex: 1,
          justifyContent: "center",
          alignItems: "center",
          bottom: 0,
        }}
      >
        <LinearGradient
          colors={["transparent", "#fff"]}
          style={{
            position: "absolute",
            width: dimensions.windowWidth,
            height: 50,
            bottom: 0,
            zIndex: 1,
          }}
        />
        <Pressable
          style={{
            height: 50,
            backgroundColor: "rgba(31, 57, 48, 1)",
            borderRadius: 50,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
            width: Platform.OS === "web" ? "95%" : "90%",
            marginHorizontal: "auto",
            zIndex: 2,
            bottom: 20,
            flexDirection: "row",
            gap: 10,
          }}
          onPress={Platform.OS === "web" ? handleShare : onShare}
        >
          <Text style={[GlobalStyles.bodyText, { color: "white" }]}>
            Share experience
          </Text>
          <ExperienceIcons.ShareIcon />
        </Pressable>
        {/* <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            paddingHorizontal: dimensions.paddingHorizontal,
          }}
        >
          <View>
            <CustomComponent.TextView
              title="Price"
              textStyle={[GlobalStyles.bodyText, { opacity: 0.5 }]}
            />
            <CustomComponent.TextView
              title={`$${experienceData?.price}`}
              textStyle={GlobalStyles.title1}
            />
          </View>
          
        </View> */}
      </View>
    </>
  );
}
